<template>
  <div>
    <common-dialog ref="dialog" width="500px" title="编辑" id-key="UserId" :data="data" @edit-opened="opened" @close-saved="$emit('close-saved')" :confirm-on-close-change="false">
      <template slot="form">
        <el-row class="border">
          
          <el-row :gutter="15">
            <el-col :span="20">
              <el-form-item label="加工设备">
                <el-select v-model="data.MaintenanceId">
                  <el-option v-for="item in equipmentList" :key="item.EquipmentId" :label="item.EquipmentName" :value="item.EquipmentId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="15">
            <el-col :span="20">
              <el-form-item label="加工单价">
                <el-input v-model="data.Wages"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </template>

      <template slot="footer">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click="closeDialog">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
  
  <script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog
  },
  props: {
    wid: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      api: require("@/api/production/workDoc").default,
      equipmentApi: require('@/api/ba/equipment').default,
      data: {
        WorkDocIds: [],
        MaintenanceId: null,
        Wages: null
      },
      scheduleList: [],
      equipmentList:[]
    }
  },
  created() {
    
    this.getequipmentList()
  },
  methods: {
    getequipmentList() {
      this.equipmentApi.list({ Statuses: [1, 2] }).then(res => {
        if (res.Code === 0) {
          this.equipmentList = res.Data
        }
      })
    },
    save() {
      // if (this.data.MaintenanceId == null || this.data.Wages == null) {
      //   this.$message({ type: 'warning', message: '请填写加工工价或加工设备' })
      //   return
      // }
      var loading = this.$loading({
        lock: true,
        text: '正在保存...',
        spinner: 'el-icon-loading',
        customClass: 'my_loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })

      this.api
        .changeWages(this.data)
        .then(res => {
          if (res.Code === 0) {
            this.$message({ type: 'success', message: res.Msg })
            this.$emit('change', this.data)
            loading.close()
            this.close()
          } else {
            this.$message({ type: 'warning', message: res.Msg })
            loading.close()
          }
        })
        .catch(err => {
          console.error(err)
          loading.close()
        })
    },
    closeDialog() {
      this.close()
    },
    opened(row) {
      console.log('row', row)
      this.data.WorkDocIds = row.WorkDocIds      
      this.data.MaintenanceId = row.MaintenanceId
      this.data.Wages = row.Wages
      this.data.type=row.type
      
    },
  }
}
</script>
  